import { FullStackTrackable } from '@chegg/optimizely-sdk'
import { cfeLogin } from '@src/state/auth/actions'
import { createTicketSuccess } from '@src/state/expertcheck/actions'
import {
  PAPER_UPLOADED_MODAL,
  PAPER_UPLOADED_NON_PLUS_MODAL,
  showModal,
} from '@src/state/modals/actions'
import { paymentSuccess } from '@src/state/payment/actions'
import { LOCATION_CHANGE } from 'connected-react-router'
import { AnyAction } from 'redux'
import { createMiddleware, EventsMapper, Target } from 'redux-beacon'
import { getType } from 'typesafe-actions'
import {
  accountCreatedEvent,
  expertCheckSubmissionEvent,
  freeTrialStartEvent,
  locationChangeEvent,
  paperUploadedEvent,
} from './events'
import { trackOptimizelyEvent } from './optimizely'

const optimizelyTarget = (): Target => (events: FullStackTrackable[]) => {
  events.forEach(event => {
    trackOptimizelyEvent && trackOptimizelyEvent(event)
  })
}

export const eventsMap: EventsMapper = (action: AnyAction) => {
  switch (action.type) {
    case getType(cfeLogin):
      return accountCreatedEvent
    case getType(paymentSuccess):
      return freeTrialStartEvent
    case getType(showModal):
      const isPaperUploadModal = [
        PAPER_UPLOADED_MODAL,
        PAPER_UPLOADED_NON_PLUS_MODAL,
      ].includes(action.payload.name)
      if (!isPaperUploadModal) {
        return []
      }
      return paperUploadedEvent
    case getType(createTicketSuccess):
      return expertCheckSubmissionEvent
    case LOCATION_CHANGE:
      return locationChangeEvent
    default:
      return []
  }
}

export const opMiddleware = createMiddleware(eventsMap, optimizelyTarget())



// WEBPACK FOOTER //
// ./src/state/optimizely/middleware.ts